/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} League_Error_CreateInputs */



/**
* | output |
* | --- |
* | "Couldn't create the league." |
*
* @param {League_Error_CreateInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const league_error_create = /** @type {((inputs?: League_Error_CreateInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<League_Error_CreateInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Impossible de créer la ligue.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se pudo crear la liga.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Não foi possível criar a liga.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile creare il campionato.")
	return /** @type {LocalizedString} */ ("Couldn't create the league.")
});